import { buildFormData, createNode, nextTick, sleep } from "@front/utils";
import { createComponent } from "@front/utils/alpine";
import prestashop from "prestashop";

function toggleBodyOverflow (force: boolean) {
    document.body.classList.toggle('md:overflow-y-hidden', force);
}

export default createComponent(() => ({
    isOpen: false,
    isModalOpen: false,
    refreshUrl: null as null | string,

    openModalWithContent (html: string) {
        const node = createNode(html);
        this.$el.appendChild(node);

        if(typeof (<any>window).pmApplePayPlugin != 'undefined')
            (<any>window).pmApplePayPlugin.showApplePayButtonsIfAvailable();

        nextTick(() => this.isModalOpen = true);
    },

    closeModal () {
        this.isModalOpen = false;
        sleep(300).then(() => this.$el.remove());
    },

    async handleUpdateCart (event: any) {
        const requestData = {};
        const addToCartForm = document.querySelector<HTMLFormElement>('.js-add-to-cart-or-refresh');

        if (event && event.reason && typeof event.resp !== 'undefined' && !event.resp.hasError) {
            Object.assign(requestData, {
                id_customization: event.reason.idCustomization,
                id_product_attribute: event.reason.idProductAttribute,
                id_product: event.reason.idProduct,
                action: event.reason.linkAction
            }, addToCartForm ? Object.fromEntries(new FormData(addToCartForm)) : {});
        }

        if (event && event.resp && event.resp.hasError) {
            prestashop.emit('showErrorNextToAddtoCartButton', { errorMessage: event.resp.errors.join('<br/>')});
        }

        const opts = {
            method: 'POST',
            body: buildFormData(requestData),
        };

        try {
            const response = await fetch(this.refreshUrl, opts)
            const data = await response.json();

            const newNode = createNode(data.preview).firstElementChild as Node;
            const oldNode = this.$el.firstElementChild as Node;
            this.$el.replaceChild(newNode, oldNode);

            data.modal ? this.openModalWithContent(data.modal) : null;
        } catch (resp) {
            prestashop.emit('handleError', { eventType: 'updateShoppingCart', resp });
        }
    },

    init () {
        this.refreshUrl = this.$el.dataset.refreshUrl;

        toggleBodyOverflow(this.isModalOpen);
        this.$watch('isModalOpen', toggleBodyOverflow);

        prestashop.on('updateCart', this.handleUpdateCart.bind(this));
    }
}));
